import React from "react";
import { Button, minLength, SimpleForm, TextInput, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import dataProvider from "server/dataProvider";
import { candidateRequests } from "api/candidateApi";
import { Typography } from "@mui/material";
import { useNotifyError } from "utils/useNotifyError";

const TransferCandidacyPaymentsDialog = ({ candidacyId, disabled }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const [isFoundCandidacy, setIsFoundCandidacy] = React.useState(false);
  const [foundCandidacy, setFoundCandidacy] = React.useState(false);

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      candidateRequests.transferCandidacyPayment(),
      { fromCandidacyId: candidacyId, toCandidacyId: foundCandidacy.candidacyId },
      "POST",
    );

    notify("Плащането е прехвърлено успешно", { type: "success" });
  };

  const handleNumberSubmit = async ({ admissionNumber }) => {
    try {
      const { data } = await dataProvider.customRequest(
        candidateRequests.searchCandidacy(),
        null,
        "GET",
        `?admissionNumber=${admissionNumber}`,
      );

      if (data && data.length > 0) {
        setFoundCandidacy(data[0]);
        setIsFoundCandidacy(true);
      } else {
        notify("Не е намерена кандидатура с този входящ номер", { type: "warning" });
        setFoundCandidacy(null);
        setIsFoundCandidacy(false);
      }
    } catch (err) {
      notifyError(err);
      setFoundCandidacy(null);
      setIsFoundCandidacy(false);
    }
  };

  const candidacyNames = foundCandidacy
    ? foundCandidacy.secondName
      ? `${foundCandidacy.firstName} ${foundCandidacy.secondName} ${foundCandidacy.lastName}`
      : `${foundCandidacy.firstName} ${foundCandidacy.lastName}`
    : null;

  return (
    <ConfirmModal
      titleContent="Прехвърляне на плащане"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          disabled={disabled}
          startIcon={<SwapHorizIcon />}
          variant="contained"
          sx={{
            mt: 2,
            fontSize: 12,
            fontWeight: 400,
            py: 1,
            px: 2,
          }}
          label="Прехвърли плащане"
        />
      }
      confirmEnabled={isFoundCandidacy}
    >
      <SimpleForm
        toolbar={false}
        onSubmit={handleNumberSubmit}
      >
        Въведете входящ номер на кандидат и натиснете "Enter"
        <TextInput
          label="Вх. Номер"
          source="admissionNumber"
          validate={[minLength(9, "Въведете поне 9 символа")]}
        />
      </SimpleForm>
      <div style={{ height: 30 }}>
        <Typography
          variant="h5"
          sx={{ marginTop: 2, textAlign: "center" }}
        >
          {candidacyNames}
        </Typography>
      </div>
    </ConfirmModal>
  );
};

export default TransferCandidacyPaymentsDialog;
